import {
  IFvSnackbarOption,
  FV_SNACKBAR_COLOR,
  FV_SNACKBAR_DISPLAY,
} from '@discocil/fv-components';
import { FV_SNACKBAR_TIME_BEFORE_CLOSE } from 'src/app/config/global-snackbar.config';

export const ticketEventInUseError: IFvSnackbarOption = {
  message: '',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.red,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: true,
  timeBeforeClose: FV_SNACKBAR_TIME_BEFORE_CLOSE.normal,
  title: 'fv_snackbar.ticket_event.ticket_in_use',
};

export const ticketEventQRError: IFvSnackbarOption = {
  message: '',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.red,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: true,
  timeBeforeClose: FV_SNACKBAR_TIME_BEFORE_CLOSE.normal,
  title: 'fv_snackbar.ticket_event.error_msg',
};

export const ticketEventConsumedError: IFvSnackbarOption = {
  message: '',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.red,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: true,
  timeBeforeClose: FV_SNACKBAR_TIME_BEFORE_CLOSE.normal,
  title: 'fv_snackbar.ticket_event.ticket_consumed',
};
